import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6b3aeb0e&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=6b3aeb0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3aeb0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3aeb0e')) {
      api.createRecord('6b3aeb0e', component.options)
    } else {
      api.reload('6b3aeb0e', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=6b3aeb0e&scoped=true", function () {
      api.rerender('6b3aeb0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/404.vue"
export default component.exports